<template>
    <b-modal
      size="md"
      :hideFooter="true"
      :hideHeader="true"
      centered
      id="leaveTestEdit"
    >
      <template slot="default">
        <b-row>
          <b-col class="float-left">
            <em class="fas fa-lg fa-exclamation"></em>
          </b-col>
        </b-row>
        <b-container class="confirm-modal-cnt">
          <b-row class="text-center mt-2">
            <h6 class="confirm-modal-text text-center w-100">
              Вы действительно хотите выйти из режима редактирования теста?
            </h6>
          </b-row>
          <b-row>
            <b-col sm="12" md="6">
              <b-button @click="onLeave" class="confirm-modal-btn" variant="primary">
                Выйти
              </b-button>
            </b-col>
            <b-col sm="12" md="6">
              <b-button @click="closeModal" class="confirm-modal-btn" variant="outline-primary">
                Отмена
              </b-button>
            </b-col>
          </b-row>
        </b-container>
      </template>
    </b-modal>
</template>

<script>

import { mapActions, mapGetters } from 'vuex'
import RouteMixin from '@/components/helpers/mixins/route-mixin'

export default {
  name: 'LeaveTestEdit',
  mixins: [RouteMixin],
  methods: {
    ...mapActions({
      fetchCourseContent: 'education/fetchCourseContent',
      updateTestCreationMode: 'test/updateTestCreationMode'
    }),
    closeModal() {
      this.$bvModal.hide('leaveTestEdit')
    },
    onLeave() {
      // this.fetchCourseContent({ id: this.$route.params.courseBookId }).then(() => {
      this.updateTestCreationMode(false)
      this.$router.push(`${this.$_getCourseRoutePrefix(this.$route.path)}${this.$route.params.courseBookId}/test/${this.editedTestId}`)
      // })
    }
  },
  computed: {
    ...mapGetters({
      editedTestId: 'test/getEditedTestId'
    })
  }
}
</script>

<style scoped lang="scss">

  .confirm-modal-btn {
    width: 100%;
  }

  .confirm-modal-text {
    text-align: center;
    margin-bottom: 20px;
  }

  .resetName {
    width: 100%;
    margin-bottom: 20px;
  }

</style>
